import React, { useEffect, useState } from 'react'
import { getRewards } from '../services/services'
import { toast } from 'react-toastify'
import { Row } from 'reactstrap';
import ObPortfolioBaseCard from '../../waitlist/components/ObPortfolioBaseCard';

function ReferralPortfolio() {
    const [rewards, setRewards] = useState([]);

    useEffect(() => {
        getRewards().then(resp => {
            if (!resp || !resp.success) {
                return toast.error("Unable to fetch data");
            }
            if (resp && resp.data) {
                const totalReward = [
                    {
                        title: "Total Rewards",
                        value: resp?.data && (resp?.data?.totalRewards)?.oroNumber(2, true) || 0
                    },
                    {
                        title: "Registered Friends",
                        value: resp?.data && resp?.data?.registered || 0
                    },
                    {
                        title: "Pending Requests",
                        value: resp?.data && resp?.data?.pending || 0
                    },
                ]
                setRewards([...totalReward]);
            }
        })
    }, []);

  return (
    <Row className="pf-row">
        {rewards && rewards.length ? rewards.map((item,index)=>(
            <ObPortfolioBaseCard title={item.title} value={item.value} isTotal={index=== 0} />
        )) : null}
    </Row>
  )
}

export default ReferralPortfolio